module.exports = __webpack_public_path__ + "img/e94cb2f.png";